import { render, staticRenderFns } from "./main.vue?vue&type=template&id=c90dcd04&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=c90dcd04&prod&lang=scss&scoped=true"
import style1 from "./main.vue?vue&type=style&index=1&id=c90dcd04&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90dcd04",
  null
  
)

export default component.exports